<app-page-head [title]="'Lembretes'"></app-page-head>

<div class="row">
  <div class="col-md-12">

    <div class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="text-center">Id</th>
            <th scope="col">Projeto</th>
            <th scope="col" class="text-center">Revista</th>
            <th scope="col" class="text-center">Status</th>
            <th scope="col" class="text-center">Data</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of reminders?.data">
            <th scope="row" class="text-center">
              {{ item?.id }}
            </th>
            <td>
              <a>
                {{ item?.project_title }}
              </a>
            </td>
            <td class="text-center">
              {{ item?.magazine }}
            </td>
            <td class="text-center">
              {{ item?.project_status }}
            </td>
            <td class="text-center">
              {{ item?.date_reminder }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
